import { isFuture } from "date-fns";
import { OfferPlanPriceBreakdown } from "./OfferPlanPriceBreakdown";
import { OfferPlanProps, PriceBreakdownProps } from "./PriceBreakdown.types";
import { BasicPlanPriceBreakdown } from "./BasicPlanPriceBreakdown";
import { NoPricePlanPriceBreakdown } from "./NoPricePlanBreakdown";
import { FreePlanPriceBreakdown } from "./FreePlanPriceBreakdown";

const isOfferEnabled = (offer: OfferPlanProps["offer"]) => {
  return !offer.validUntil || isFuture(offer.validUntil);
};

export const PriceBreakdown = (props: PriceBreakdownProps) => {
  const {
    price,
    productName,
    productDescription,
    currency = "USD",
    offer,
    planName,
    planTrialDays,
    partner,
    hideMarketingCopy,
  } = props;

  if (price === undefined) {
    return (
      <NoPricePlanPriceBreakdown
        productName={productName}
        productDescription={productDescription}
        partner={partner}
        hideMarketingCopy={hideMarketingCopy}
      />
    );
  }

  if (!offer && price === 0 && planTrialDays === 0) {
    return (
      <FreePlanPriceBreakdown
        productName={productName}
        productDescription={productDescription}
        planName={planName}
        partner={partner}
        hideMarketingCopy={hideMarketingCopy}
      />
    );
  }

  // A real offer wins; otherwise fall back to the plan's own trial length.
  const effectiveOffer =
    offer ??
    (planTrialDays > 0
      ? { id: "plan-trial", trialDays: planTrialDays }
      : undefined);

  if (effectiveOffer && isOfferEnabled(effectiveOffer)) {
    return (
      <OfferPlanPriceBreakdown
        price={price}
        productName={productName}
        productDescription={productDescription}
        planTrialDays={planTrialDays}
        currency={currency}
        offer={effectiveOffer}
        planName={planName}
        partner={partner}
        creditCardRequired={props.creditCardRequired}
        hideMarketingCopy={hideMarketingCopy}
      />
    );
  }

  return (
    <BasicPlanPriceBreakdown
      price={price}
      productName={productName}
      productDescription={productDescription}
      planTrialDays={planTrialDays}
      currency={currency}
      partner={partner}
      creditCardRequired={props.creditCardRequired}
      hideMarketingCopy={hideMarketingCopy}
    />
  );
};
